<wa-dialog [attr.label]="label()" [lightDismiss]="lightDismiss()" [open]="open()" (wa-hide)="onHide($event)">
    @if (open()) {
        <ng-content />
    }
</wa-dialog>
